// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/service_principal/v1/service_principal.proto" (package "c1.api.service_principal.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { User } from "../../user/v1/user";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * ServicePrincipal represents a tenant-managed non-human identity.
 *
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipal
 */
export interface ServicePrincipal {
    /**
     * The unique user ID of the service principal.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The display name of the service principal.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * The datetime when the service principal was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime when the service principal was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The underlying user object.
     *
     * @generated from protobuf field: c1.api.user.v1.User user = 5
     */
    user?: User;
}
/**
 * ServicePrincipalCredential represents a client credential for a service principal.
 *
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalCredential
 */
export interface ServicePrincipalCredential {
    /**
     * The unique ID of the credential (cutename format).
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The service principal user ID this credential belongs to.
     *
     * @generated from protobuf field: string service_principal_id = 2
     */
    servicePrincipalId: string;
    /**
     * The display name of the credential.
     *
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * The full client ID in format: ${cutename}@${tenant}.${installation}/spc
     *
     * @generated from protobuf field: string client_id = 4
     */
    clientId: string;
    /**
     * The datetime when the credential was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * The datetime when the credential expires.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 6
     */
    expiresAt?: Timestamp;
    /**
     * The datetime when the credential was last used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 7
     */
    lastUsedAt?: Timestamp;
    /**
     * Whether DPoP proof-of-possession is required for this credential.
     *
     * @generated from protobuf field: bool require_dpop = 8
     */
    requireDpop: boolean;
    /**
     * Scoped role IDs for this credential (intersection with SP roles at token issuance).
     *
     * @generated from protobuf field: repeated string scoped_role_ids = 9
     */
    scopedRoleIds: string[];
    /**
     * CIDR restrictions for this credential.
     *
     * @generated from protobuf field: repeated string allow_source_cidrs = 10
     */
    allowSourceCidrs: string[];
}
/**
 * ServicePrincipalRef is a reference to a service principal by ID.
 *
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalRef
 */
export interface ServicePrincipalRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// --- Create ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateRequest
 */
export interface ServicePrincipalServiceCreateRequest {
    /**
     * The display name for the new service principal.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateResponse
 */
export interface ServicePrincipalServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipal service_principal = 1
     */
    servicePrincipal?: ServicePrincipal;
}
// --- Get ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetRequest
 */
export interface ServicePrincipalServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetResponse
 */
export interface ServicePrincipalServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipal service_principal = 1
     */
    servicePrincipal?: ServicePrincipal;
}
// --- Update ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateRequest
 */
export interface ServicePrincipalServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipal service_principal = 1
     */
    servicePrincipal?: ServicePrincipal;
    /**
     * Required. The fields to update. Currently supports: "display_name".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateResponse
 */
export interface ServicePrincipalServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipal service_principal = 1
     */
    servicePrincipal?: ServicePrincipal;
}
// --- Delete ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceDeleteRequest
 */
export interface ServicePrincipalServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceDeleteResponse
 */
export interface ServicePrincipalServiceDeleteResponse {
}
// --- List ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListRequest
 */
export interface ServicePrincipalServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListResponse
 */
export interface ServicePrincipalServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.service_principal.v1.ServicePrincipal list = 1
     */
    list: ServicePrincipal[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// --- CreateCredential ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialRequest
 */
export interface ServicePrincipalServiceCreateCredentialRequest {
    /**
     * The service principal ID to create the credential for.
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The display name for the new credential.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * The list of roles to restrict the credential to.
     *
     * @generated from protobuf field: repeated string scoped_roles = 3
     */
    scopedRoles: string[];
    /**
     * How long until the credential expires. Maximum 180 days.
     *
     * @generated from protobuf field: google.protobuf.Duration expires = 4
     */
    expires?: Duration;
    /**
     * A list of CIDRs to restrict this credential to.
     *
     * @generated from protobuf field: repeated string allow_source_cidrs = 5
     */
    allowSourceCidrs: string[];
    /**
     * If true, requires DPoP proof-of-possession for token exchange using this credential.
     *
     * @generated from protobuf field: bool require_dpop = 6
     */
    requireDpop: boolean;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialResponse
 */
export interface ServicePrincipalServiceCreateCredentialResponse {
    /**
     * The created credential metadata.
     *
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipalCredential credential = 1
     */
    credential?: ServicePrincipalCredential;
    /**
     * The client secret. Shown exactly once at creation -- cannot be retrieved again.
     *
     * @generated from protobuf field: string client_secret = 2
     */
    clientSecret: string;
}
// --- ListCredentials ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsRequest
 */
export interface ServicePrincipalServiceListCredentialsRequest {
    /**
     * The service principal ID to list credentials for.
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsResponse
 */
export interface ServicePrincipalServiceListCredentialsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.service_principal.v1.ServicePrincipalCredential list = 1
     */
    list: ServicePrincipalCredential[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// --- GetCredential ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialRequest
 */
export interface ServicePrincipalServiceGetCredentialRequest {
    /**
     * The service principal ID.
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The credential ID to get.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialResponse
 */
export interface ServicePrincipalServiceGetCredentialResponse {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipalCredential credential = 1
     */
    credential?: ServicePrincipalCredential;
}
// --- UpdateCredential ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialRequest
 */
export interface ServicePrincipalServiceUpdateCredentialRequest {
    /**
     * The service principal ID.
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The credential to update.
     *
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipalCredential credential = 2
     */
    credential?: ServicePrincipalCredential;
    /**
     * The fields to update.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialResponse
 */
export interface ServicePrincipalServiceUpdateCredentialResponse {
    /**
     * @generated from protobuf field: c1.api.service_principal.v1.ServicePrincipalCredential credential = 1
     */
    credential?: ServicePrincipalCredential;
}
// --- RevokeCredential ---

/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialRequest
 */
export interface ServicePrincipalServiceRevokeCredentialRequest {
    /**
     * The service principal ID.
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The credential ID to revoke.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialResponse
 */
export interface ServicePrincipalServiceRevokeCredentialResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipal$Type extends MessageType<ServicePrincipal> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipal", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "user", kind: "message", T: () => User, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "service_principal", keyFields: ["id"] } });
    }
    create(value?: PartialMessage<ServicePrincipal>): ServicePrincipal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipal): ServicePrincipal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* c1.api.user.v1.User user */ 5:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.User user = 5; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipal
 */
export const ServicePrincipal = new ServicePrincipal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalCredential$Type extends MessageType<ServicePrincipalCredential> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalCredential", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 4, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "require_dpop", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "scoped_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "allow_source_cidrs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalCredential>): ServicePrincipalCredential {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.servicePrincipalId = "";
        message.displayName = "";
        message.clientId = "";
        message.requireDpop = false;
        message.scopedRoleIds = [];
        message.allowSourceCidrs = [];
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalCredential>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalCredential): ServicePrincipalCredential {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string service_principal_id */ 2:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string client_id */ 4:
                    message.clientId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 6:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* google.protobuf.Timestamp last_used_at */ 7:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                case /* bool require_dpop */ 8:
                    message.requireDpop = reader.bool();
                    break;
                case /* repeated string scoped_role_ids */ 9:
                    message.scopedRoleIds.push(reader.string());
                    break;
                case /* repeated string allow_source_cidrs */ 10:
                    message.allowSourceCidrs.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalCredential, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string service_principal_id = 2; */
        if (message.servicePrincipalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string client_id = 4; */
        if (message.clientId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.clientId);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 6; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used_at = 7; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool require_dpop = 8; */
        if (message.requireDpop !== false)
            writer.tag(8, WireType.Varint).bool(message.requireDpop);
        /* repeated string scoped_role_ids = 9; */
        for (let i = 0; i < message.scopedRoleIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.scopedRoleIds[i]);
        /* repeated string allow_source_cidrs = 10; */
        for (let i = 0; i < message.allowSourceCidrs.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.allowSourceCidrs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalCredential
 */
export const ServicePrincipalCredential = new ServicePrincipalCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalRef$Type extends MessageType<ServicePrincipalRef> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalRef>): ServicePrincipalRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalRef): ServicePrincipalRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalRef
 */
export const ServicePrincipalRef = new ServicePrincipalRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceCreateRequest$Type extends MessageType<ServicePrincipalServiceCreateRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceCreateRequest>): ServicePrincipalServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceCreateRequest): ServicePrincipalServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateRequest
 */
export const ServicePrincipalServiceCreateRequest = new ServicePrincipalServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceCreateResponse$Type extends MessageType<ServicePrincipalServiceCreateResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceCreateResponse", [
            { no: 1, name: "service_principal", kind: "message", T: () => ServicePrincipal }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceCreateResponse>): ServicePrincipalServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceCreateResponse): ServicePrincipalServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipal service_principal */ 1:
                    message.servicePrincipal = ServicePrincipal.internalBinaryRead(reader, reader.uint32(), options, message.servicePrincipal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipal service_principal = 1; */
        if (message.servicePrincipal)
            ServicePrincipal.internalBinaryWrite(message.servicePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateResponse
 */
export const ServicePrincipalServiceCreateResponse = new ServicePrincipalServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceGetRequest$Type extends MessageType<ServicePrincipalServiceGetRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceGetRequest>): ServicePrincipalServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceGetRequest): ServicePrincipalServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetRequest
 */
export const ServicePrincipalServiceGetRequest = new ServicePrincipalServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceGetResponse$Type extends MessageType<ServicePrincipalServiceGetResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceGetResponse", [
            { no: 1, name: "service_principal", kind: "message", T: () => ServicePrincipal }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceGetResponse>): ServicePrincipalServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceGetResponse): ServicePrincipalServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipal service_principal */ 1:
                    message.servicePrincipal = ServicePrincipal.internalBinaryRead(reader, reader.uint32(), options, message.servicePrincipal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipal service_principal = 1; */
        if (message.servicePrincipal)
            ServicePrincipal.internalBinaryWrite(message.servicePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetResponse
 */
export const ServicePrincipalServiceGetResponse = new ServicePrincipalServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceUpdateRequest$Type extends MessageType<ServicePrincipalServiceUpdateRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceUpdateRequest", [
            { no: 1, name: "service_principal", kind: "message", T: () => ServicePrincipal, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceUpdateRequest>): ServicePrincipalServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceUpdateRequest): ServicePrincipalServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipal service_principal */ 1:
                    message.servicePrincipal = ServicePrincipal.internalBinaryRead(reader, reader.uint32(), options, message.servicePrincipal);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipal service_principal = 1; */
        if (message.servicePrincipal)
            ServicePrincipal.internalBinaryWrite(message.servicePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateRequest
 */
export const ServicePrincipalServiceUpdateRequest = new ServicePrincipalServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceUpdateResponse$Type extends MessageType<ServicePrincipalServiceUpdateResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceUpdateResponse", [
            { no: 1, name: "service_principal", kind: "message", T: () => ServicePrincipal }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceUpdateResponse>): ServicePrincipalServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceUpdateResponse): ServicePrincipalServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipal service_principal */ 1:
                    message.servicePrincipal = ServicePrincipal.internalBinaryRead(reader, reader.uint32(), options, message.servicePrincipal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipal service_principal = 1; */
        if (message.servicePrincipal)
            ServicePrincipal.internalBinaryWrite(message.servicePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateResponse
 */
export const ServicePrincipalServiceUpdateResponse = new ServicePrincipalServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceDeleteRequest$Type extends MessageType<ServicePrincipalServiceDeleteRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceDeleteRequest>): ServicePrincipalServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceDeleteRequest): ServicePrincipalServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceDeleteRequest
 */
export const ServicePrincipalServiceDeleteRequest = new ServicePrincipalServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceDeleteResponse$Type extends MessageType<ServicePrincipalServiceDeleteResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ServicePrincipalServiceDeleteResponse>): ServicePrincipalServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceDeleteResponse): ServicePrincipalServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceDeleteResponse
 */
export const ServicePrincipalServiceDeleteResponse = new ServicePrincipalServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceListRequest$Type extends MessageType<ServicePrincipalServiceListRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceListRequest>): ServicePrincipalServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceListRequest): ServicePrincipalServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListRequest
 */
export const ServicePrincipalServiceListRequest = new ServicePrincipalServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceListResponse$Type extends MessageType<ServicePrincipalServiceListResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicePrincipal },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceListResponse>): ServicePrincipalServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceListResponse): ServicePrincipalServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.service_principal.v1.ServicePrincipal list */ 1:
                    message.list.push(ServicePrincipal.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.service_principal.v1.ServicePrincipal list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ServicePrincipal.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListResponse
 */
export const ServicePrincipalServiceListResponse = new ServicePrincipalServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceCreateCredentialRequest$Type extends MessageType<ServicePrincipalServiceCreateCredentialRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "scoped_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "expires", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: true, lte: { seconds: "15552000" }, gt: {} } } } },
            { no: 5, name: "allow_source_cidrs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } },
            { no: 6, name: "require_dpop", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceCreateCredentialRequest>): ServicePrincipalServiceCreateCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.displayName = "";
        message.scopedRoles = [];
        message.allowSourceCidrs = [];
        message.requireDpop = false;
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceCreateCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceCreateCredentialRequest): ServicePrincipalServiceCreateCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* repeated string scoped_roles */ 3:
                    message.scopedRoles.push(reader.string());
                    break;
                case /* google.protobuf.Duration expires */ 4:
                    message.expires = Duration.internalBinaryRead(reader, reader.uint32(), options, message.expires);
                    break;
                case /* repeated string allow_source_cidrs */ 5:
                    message.allowSourceCidrs.push(reader.string());
                    break;
                case /* bool require_dpop */ 6:
                    message.requireDpop = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceCreateCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* repeated string scoped_roles = 3; */
        for (let i = 0; i < message.scopedRoles.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.scopedRoles[i]);
        /* google.protobuf.Duration expires = 4; */
        if (message.expires)
            Duration.internalBinaryWrite(message.expires, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string allow_source_cidrs = 5; */
        for (let i = 0; i < message.allowSourceCidrs.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.allowSourceCidrs[i]);
        /* bool require_dpop = 6; */
        if (message.requireDpop !== false)
            writer.tag(6, WireType.Varint).bool(message.requireDpop);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialRequest
 */
export const ServicePrincipalServiceCreateCredentialRequest = new ServicePrincipalServiceCreateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceCreateCredentialResponse$Type extends MessageType<ServicePrincipalServiceCreateCredentialResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ServicePrincipalCredential },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceCreateCredentialResponse>): ServicePrincipalServiceCreateCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceCreateCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceCreateCredentialResponse): ServicePrincipalServiceCreateCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipalCredential credential */ 1:
                    message.credential = ServicePrincipalCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                case /* string client_secret */ 2:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceCreateCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipalCredential credential = 1; */
        if (message.credential)
            ServicePrincipalCredential.internalBinaryWrite(message.credential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string client_secret = 2; */
        if (message.clientSecret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceCreateCredentialResponse
 */
export const ServicePrincipalServiceCreateCredentialResponse = new ServicePrincipalServiceCreateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceListCredentialsRequest$Type extends MessageType<ServicePrincipalServiceListCredentialsRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceListCredentialsRequest>): ServicePrincipalServiceListCredentialsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceListCredentialsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceListCredentialsRequest): ServicePrincipalServiceListCredentialsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceListCredentialsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsRequest
 */
export const ServicePrincipalServiceListCredentialsRequest = new ServicePrincipalServiceListCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceListCredentialsResponse$Type extends MessageType<ServicePrincipalServiceListCredentialsResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicePrincipalCredential },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceListCredentialsResponse>): ServicePrincipalServiceListCredentialsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceListCredentialsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceListCredentialsResponse): ServicePrincipalServiceListCredentialsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.service_principal.v1.ServicePrincipalCredential list */ 1:
                    message.list.push(ServicePrincipalCredential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceListCredentialsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.service_principal.v1.ServicePrincipalCredential list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ServicePrincipalCredential.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceListCredentialsResponse
 */
export const ServicePrincipalServiceListCredentialsResponse = new ServicePrincipalServiceListCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceGetCredentialRequest$Type extends MessageType<ServicePrincipalServiceGetCredentialRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceGetCredentialRequest>): ServicePrincipalServiceGetCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceGetCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceGetCredentialRequest): ServicePrincipalServiceGetCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceGetCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialRequest
 */
export const ServicePrincipalServiceGetCredentialRequest = new ServicePrincipalServiceGetCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceGetCredentialResponse$Type extends MessageType<ServicePrincipalServiceGetCredentialResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ServicePrincipalCredential }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceGetCredentialResponse>): ServicePrincipalServiceGetCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceGetCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceGetCredentialResponse): ServicePrincipalServiceGetCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipalCredential credential */ 1:
                    message.credential = ServicePrincipalCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceGetCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipalCredential credential = 1; */
        if (message.credential)
            ServicePrincipalCredential.internalBinaryWrite(message.credential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceGetCredentialResponse
 */
export const ServicePrincipalServiceGetCredentialResponse = new ServicePrincipalServiceGetCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceUpdateCredentialRequest$Type extends MessageType<ServicePrincipalServiceUpdateCredentialRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "credential", kind: "message", T: () => ServicePrincipalCredential, options: { "validate.rules": { message: { required: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceUpdateCredentialRequest>): ServicePrincipalServiceUpdateCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceUpdateCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceUpdateCredentialRequest): ServicePrincipalServiceUpdateCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* c1.api.service_principal.v1.ServicePrincipalCredential credential */ 2:
                    message.credential = ServicePrincipalCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceUpdateCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* c1.api.service_principal.v1.ServicePrincipalCredential credential = 2; */
        if (message.credential)
            ServicePrincipalCredential.internalBinaryWrite(message.credential, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialRequest
 */
export const ServicePrincipalServiceUpdateCredentialRequest = new ServicePrincipalServiceUpdateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceUpdateCredentialResponse$Type extends MessageType<ServicePrincipalServiceUpdateCredentialResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ServicePrincipalCredential }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceUpdateCredentialResponse>): ServicePrincipalServiceUpdateCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceUpdateCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceUpdateCredentialResponse): ServicePrincipalServiceUpdateCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.service_principal.v1.ServicePrincipalCredential credential */ 1:
                    message.credential = ServicePrincipalCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceUpdateCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.service_principal.v1.ServicePrincipalCredential credential = 1; */
        if (message.credential)
            ServicePrincipalCredential.internalBinaryWrite(message.credential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceUpdateCredentialResponse
 */
export const ServicePrincipalServiceUpdateCredentialResponse = new ServicePrincipalServiceUpdateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceRevokeCredentialRequest$Type extends MessageType<ServicePrincipalServiceRevokeCredentialRequest> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ServicePrincipalServiceRevokeCredentialRequest>): ServicePrincipalServiceRevokeCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceRevokeCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceRevokeCredentialRequest): ServicePrincipalServiceRevokeCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceRevokeCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialRequest
 */
export const ServicePrincipalServiceRevokeCredentialRequest = new ServicePrincipalServiceRevokeCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePrincipalServiceRevokeCredentialResponse$Type extends MessageType<ServicePrincipalServiceRevokeCredentialResponse> {
    constructor() {
        super("c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialResponse", []);
    }
    create(value?: PartialMessage<ServicePrincipalServiceRevokeCredentialResponse>): ServicePrincipalServiceRevokeCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ServicePrincipalServiceRevokeCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServicePrincipalServiceRevokeCredentialResponse): ServicePrincipalServiceRevokeCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServicePrincipalServiceRevokeCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.service_principal.v1.ServicePrincipalServiceRevokeCredentialResponse
 */
export const ServicePrincipalServiceRevokeCredentialResponse = new ServicePrincipalServiceRevokeCredentialResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.service_principal.v1.ServicePrincipalService
 */
export const ServicePrincipalService = new ServiceType("c1.api.service_principal.v1.ServicePrincipalService", [
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/service_principals", group: "Service Principal" }] }, "authz.method": { role: "OWNER" } }, I: ServicePrincipalServiceCreateRequest, O: ServicePrincipalServiceCreateResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals/{id}", group: "Service Principal" }] }, "authz.method": { role: "VIEWER" } }, I: ServicePrincipalServiceGetRequest, O: ServicePrincipalServiceGetResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "PATCH", route: "/api/v1/service_principals/{service_principal.id}", group: "Service Principal" }] }, "authz.method": { role: "EDITOR" } }, I: ServicePrincipalServiceUpdateRequest, O: ServicePrincipalServiceUpdateResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/service_principals/{id}", group: "Service Principal" }] }, "authz.method": { role: "EDITOR" } }, I: ServicePrincipalServiceDeleteRequest, O: ServicePrincipalServiceDeleteResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals", group: "Service Principal" }] }, "authz.method": { role: "VIEWER" } }, I: ServicePrincipalServiceListRequest, O: ServicePrincipalServiceListResponse },
    { name: "CreateCredential", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/service_principals/{service_principal_id}/credentials", group: "Service Principal" }] }, "authz.method": { role: "EDITOR" } }, I: ServicePrincipalServiceCreateCredentialRequest, O: ServicePrincipalServiceCreateCredentialResponse },
    { name: "ListCredentials", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals/{service_principal_id}/credentials", group: "Service Principal" }] }, "authz.method": { role: "VIEWER" } }, I: ServicePrincipalServiceListCredentialsRequest, O: ServicePrincipalServiceListCredentialsResponse },
    { name: "GetCredential", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals/{service_principal_id}/credentials/{id}", group: "Service Principal" }] }, "authz.method": { role: "VIEWER" } }, I: ServicePrincipalServiceGetCredentialRequest, O: ServicePrincipalServiceGetCredentialResponse },
    { name: "UpdateCredential", options: { "apigw.v1.method": { operations: [{ method: "PATCH", route: "/api/v1/service_principals/{service_principal_id}/credentials/{credential.id}", group: "Service Principal" }] }, "authz.method": { role: "EDITOR" } }, I: ServicePrincipalServiceUpdateCredentialRequest, O: ServicePrincipalServiceUpdateCredentialResponse },
    { name: "RevokeCredential", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/service_principals/{service_principal_id}/credentials/{id}", group: "Service Principal" }] }, "authz.method": { role: "EDITOR" } }, I: ServicePrincipalServiceRevokeCredentialRequest, O: ServicePrincipalServiceRevokeCredentialResponse }
]);
